import React from 'react'
import { SVGProps } from './types'

export const Asterisk: React.FC<SVGProps> = ({
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick && (() => onClick())}
    >
      <path d="M12 6v12" fill="none" />
      <path d="M17.196 9 6.804 15" fill="none" />
      <path d="m6.804 9 10.392 6" fill="none" />
    </svg>
  )
}
